export class SetPasswordInformation {
    resetId: string;
    password: string;
    confirmPassword: string;
    passwordStrength: number;
}